<div class="membership-payment" *ngIf="!showTnc; else tnc">
  <div class="payment-card flex">
    <div class="payment-img flex-col-pay flex">
      <img [src]="images?.LOCKED_SM" class="wd-100-hg-100" alt="close" />
    </div>
    <div class="payment-action flex-col-pay flex">
      <div class="key-info">
        {{ 'YOUR_UNPAID_BALANCE' | fallbackTranslate }}
        <span class="fw-600">{{ currency }} {{ paymentDetails?.finalBill_text }}</span>
        {{ 'FOR_THE_MONTH_OF' | fallbackTranslate }}
        <span class="fw-600">{{ currentMonth }}</span>
        {{ 'IS_DUE' | fallbackTranslate }}
      </div>
      <div class="key-info">
        <span class="fw-600">{{ 'PAY_NOW' | fallbackTranslate }}</span>
        {{ 'TO_UNLOCK_YOUR_SYSTEM' | fallbackTranslate }}
      </div>
      <div class="flex flex_row align_center">
        <div class="p-t-5"> 
          <mat-checkbox
           [checked]="reoccurChecked"
           (change)="reoccurCheckHandler($event)"
          >
          </mat-checkbox>
        </div> 
        <div class="m-l-10 m-t-15 m-b-10">
         <div class="flex flex_row align_center fs-14 fw-600"> {{ 'REOCCUR_TEXT' | fallbackTranslate }}   <p class="m-l-5 fs-14 fw-400 m-b-0 link-cls" (click)="openReOccurHowWorks()">{{ 'KNOW_MORE_TEXT' | fallbackTranslate }}</p></div>
         <div class="fs-14 clr-auto">{{ 'AUTO_MATIC_TEXT' | fallbackTranslate }}</div>
        </div> 
       </div>
      <div class="action-button wd-100 flex-space flex membership-payment">
        <button nz-button nzType="primary" nzGhost class="wd-100 flex-1 cta" nzSize="large" (click)="download()">
          <img [src]="images?.DOWNLOAD" class="img-14 m-r-5" alt="close" />
          {{ 'DOWNLOAD_DETAILS' | fallbackTranslate }}
        </button>
        <button nz-button nzGhost nzType="primary" class="wd-100 flex-1 cta" nzSize="large" (click)="askForReocurrInfoandPay(false)">
          <div class="flex_sb flex_column">
            {{ 'AFTER_PROMISE.PAY_FULL_AMOUNT' | fallbackTranslate }}
            <span class="fs-12">{{ 'AFTER_PROMISE.TO_CONTINUE_WITH' | fallbackTranslate }}</span>
          </div>
        </button>
      </div>
      <div class="or" translate>OR</div>
    </div>
    <div class="payment-lite flex-col-pay flex">
      <div class="lite-header">
        {{ 'AFTER_PROMISE.PAY_ONLY' | fallbackTranslate }} {{ paymentDetails?.payOnlyPercentage }}% <span class="fs-20 grey-span">{{ 'AFTER_PROMISE.OF_YOUR_BILL' | fallbackTranslate }}<br />{{ 'AFTER_PROMISE.AT_JUST' | fallbackTranslate }}</span> {{ currency }} {{ paymentDetails?.liteAmount_text }}/{{ 'AFTER_PROMISE.MONTH_TEXT' | fallbackTranslate }}
      </div>
      <div class="lite-img grey-span">
        {{ 'AFTER_PROMISE.WITH' | fallbackTranslate }}
        <img [src]="images?.LITE" width="140" alt="easyeat-lite" />
      </div>
      <div class="lite-info">
        <div class="whats-included">
          <div class="fs-16 fw-700">{{ 'AFTER_PROMISE.WHATS_INCLUDED' | fallbackTranslate }}</div>
          <div class="flex align_center gap-2" *ngFor="let data of liteInfo.WHATS_INCLUDED">
            <img [src]="images?.SUCCESS_TICK" width="16" alt="close" />
            {{data}}
          </div>
        </div>
        <div class="separator"></div>
        <div class="whats-not-included">
          <div class="fs-16 fw-700">
            {{ 'AFTER_PROMISE.WHATS_NOT_INCLUDED' | fallbackTranslate }}
          </div>
          <div class="flex align_center gap-2" *ngFor="let data of liteInfo.WHATS_NOT_INCLUDED">
            <img [src]="images?.FAILED_CROSS" width="16" alt="close" />
            {{data}}
          </div>
        </div>
      </div>
      <div class="lite-tnc grey-span">
        <label nz-checkbox [(ngModel)]="tncChecked"></label>
        {{ 'AFTER_PROMISE.TNC_1' | fallbackTranslate }} <span (click)="toggleTnc()" class="tnc-blue">{{ 'AFTER_PROMISE.TNC' | fallbackTranslate }}</span> {{ 'AFTER_PROMISE.TNC_2' | fallbackTranslate }}
      </div>
      <button [disabled]="!tncChecked" nz-button nzType="primary" class="wd-100 flex-1 cta lite-payment-btn"
        nzSize="large" (click)="askForReocurrInfoandPay(true)">
        <div class="flex_sb flex_column">
          {{ 'AFTER_PROMISE.SWITCH_TO_EASYEAT_LITE' | fallbackTranslate }}
          <span class="fs-12">{{ 'PAY' | fallbackTranslate }} {{ currency }} {{ paymentDetails?.payOnlyAmount_text }} {{ 'AFTER_PROMISE.UNPAID_AMOUNT' | fallbackTranslate }} + {{ currency }} {{ paymentDetails?.liteAmount_text }} {{ 'AFTER_PROMISE.EASYEAT_LITE_MONTHLY_SUBSCRIPTION' | fallbackTranslate }}</span>
        </div>
      </button>
    </div>
  </div>
</div>

<ng-template #tnc>
  <div class="tnc-container">
    <button nzType="primary" nz-button nzSize="large" (click)="toggleTnc()">Go Back</button>
    <iframe title="Terms and Conditions" src="https://docs.google.com/document/d/e/2PACX-1vRLuCJK70de0Uy19CC8lRdeRaXxNKiMwda4ORjqHwvvUHN4YLLb9WvCL7eA5VRNyZnYAEH8UPfnD0ny/pub?embedded=true" class="tnc-iframe"></iframe>
  </div>
</ng-template>